import type { Epic, QaTicket, QaTicketStatus } from '@/features/project-board/types';

/** 대시보드 QA 요약에 필요한 파생 데이터. */
export class DashboardQa {
  static scheduledEpicsOf(epics: readonly Epic[]): Epic[] {
    return epics
      .filter((epic) => epic.qaSchedule?.reviewStart || epic.qaSchedule?.releaseTarget)
      .sort((left, right) => this.firstDateOf(left).localeCompare(this.firstDateOf(right)));
  }

  static ticketCountsOf(tickets: readonly QaTicket[]): Record<QaTicketStatus, number> {
    const counts: Record<QaTicketStatus, number> = {
      'No Run': 0,
      Pass: 0,
      Fail: 0,
      Block: 0,
      'N/A': 0,
      Skip: 0,
    };
    for (const ticket of tickets) counts[ticket.status] += 1;
    return counts;
  }

  static firstDateOf(epic: Epic): string {
    return [epic.qaSchedule?.reviewStart, epic.qaSchedule?.releaseTarget]
      .filter((date): date is string => date !== null && date !== undefined)
      .sort()[0] ?? '';
  }
}
